import React from "react";
import ButtonBasic from "./ButtonBasic";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";

const ButtonCreate = ({ label, ariaLabel, id, cypressid, style: userStyles = {}, ...props }) => {
  return (
    <React.Fragment>
      <ButtonBasic label={label} ariaLabel={ariaLabel} id={id} style={userStyles} cypressid={cypressid} {...props}>
        <FontAwesomeIcon className='font-icon' icon={faPlus} aria-hidden="true" />
      </ButtonBasic>
    </React.Fragment>
  );
};

ButtonCreate.defaultProps = {
  label: "Add",
  cypressid: "create"
};

export default ButtonCreate;
